import { Col, Form, FormProps, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import CustomSelect from '../../../../components/Select/Select';
import TextInput from '../../../../components/TextInput/TextInput';

export type customSAddNewBankAccountFormProps = FormProps &
  React.PropsWithRef<{
    handleOnSubmit: (formData: any) => void;
  }>;

const AddNewBankAccountForm = ({
  handleOnSubmit,
  ...props
}: customSAddNewBankAccountFormProps) => {
  const { getValues, control } = useForm({});

  const selectOptions = [
    { value: '1', label: 'Checking' },
    { value: '2', label: 'Savings' },
  ];

  const handleSubmitForm = () => {
    handleOnSubmit(getValues());
  };

  return (
    <Form onChange={handleSubmitForm} {...props}>
      <Row className="m-0 d-flex flex-column flex-lg-row justify-content-lg-between">
        <Col className="p-0 pe-lg-3">
          <Controller
            name={'accountNickname'}
            control={control}
            render={({ field }) => (
              <TextInput label="Account Nickname" className="mt-7" {...field} />
            )}
          />
        </Col>
        <Col className="p-0 ps-lg-3">
          <Controller
            name={'type'}
            control={control}
            render={({ field }) => (
              <CustomSelect
                label="Account Type"
                placeholder="Select Account Type"
                className="mt-7"
                options={selectOptions}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row className="m-0 d-flex flex-column flex-lg-row justify-content-lg-between">
        <Col className="p-0 pe-lg-3">
          <Controller
            name={'routingNumber'}
            control={control}
            render={({ field }) => (
              <TextInput label="Routing Number" className="mt-7" {...field} />
            )}
          />
        </Col>
        <Col className="p-0 ps-lg-3">
          <Controller
            name={'institutionName'}
            control={control}
            render={({ field }) => (
              <TextInput label="Institution Name" className="mt-7" {...field} />
            )}
          />
        </Col>
      </Row>
      <Row className="m-0 d-flex flex-column flex-lg-row justify-content-lg-between">
        <Col className="p-0 pe-lg-3">
          <Controller
            name={'accountNumber'}
            control={control}
            render={({ field }) => (
              <TextInput label="Account Number" className="mt-7" {...field} />
            )}
          />
        </Col>
        <Col className="p-0 ps-lg-3">
          <Controller
            name={'reEnterAccountNumber'}
            control={control}
            render={({ field }) => (
              <TextInput
                label="Re-enter Account Number"
                className="mt-7"
                {...field}
              />
            )}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddNewBankAccountForm;
